<template>
  <v-select
    :value="value"
    :items="options"
    dense
    outlined
    hide-details
    background-color="white"
    color="#13736f"
    prepend-inner-icon="mdi-sort"
    @change="$emit('input', $event)"
  ></v-select>
</template>

<script>
// Sort picker for list pages where column headers aren't visible: card
// layouts, and tables that collapse into cards on small screens.
// v-model is serverSortMixin's sortKey; headers are v-data-table headers.
export default {
  name: "TableSortSelect",
  props: {
    value: {
      type: String,
      default: "",
    },
    headers: {
      type: Array,
      required: true,
    },
  },
  computed: {
    options() {
      const options = [{ text: "Default order", value: "" }];
      this.headers
        .filter((h) => h.sortable !== false)
        .forEach((h) => {
          options.push({ text: `${h.text} (ascending)`, value: `${h.value}|asc` });
          options.push({ text: `${h.text} (descending)`, value: `${h.value}|desc` });
        });
      return options;
    },
  },
};
</script>
